import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const SHORTCUTS: ReadonlyArray<{ keys: string[]; label: string }> = [
  { keys: ['j'], label: 'Move down' },
  { keys: ['k'], label: 'Move up' },
  { keys: ['Enter'], label: 'Open alert detail' },
  { keys: ['Space'], label: 'Toggle row selection' },
  { keys: ['Shift', 'j/k'], label: 'Extend selection' },
  { keys: ['x'], label: 'Toggle select-all on screen' },
  { keys: ['/'], label: 'Focus search' },
  { keys: ['Esc'], label: 'Clear selection' },
  { keys: ['?'], label: 'Show this dialog' },
]

export function ShortcutsModal({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>Speed up triage with these keys.</DialogDescription>
        </DialogHeader>
        <ul className="flex flex-col gap-2">
          {SHORTCUTS.map((s) => (
            <li key={s.label} className="flex items-center justify-between gap-4 text-sm">
              <span className="text-fg">{s.label}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k, i) => (
                  <span key={i}>
                    {i > 0 && <span className="px-1 text-muted-fg">+</span>}
                    <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-xs">
                      {k}
                    </kbd>
                  </span>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
